/**
 * Identificação do aparelho e chaves de consulta compartilhadas (ERP Web e CaféGestor
 * Vendedor). O identificador do aparelho não é segredo: só registra de onde veio a
 * emissão/impressão/venda.
 */

/** Prefixo das consultas fiscais (invalidar tudo o que é fiscal de uma vez). */
export const FISCAL_KEY = ["fiscal"];

/** Identificador estável deste aparelho (para registrar de onde veio a emissão/impressão). */
export function deviceId(): string {
  const KEY = "cafegestor.deviceId";
  try {
    const found = localStorage.getItem(KEY);
    if (found && /^[A-Za-z0-9._-]{8,64}$/.test(found)) return found;
    const created = `disp-${crypto.randomUUID().slice(0, 18)}`;
    localStorage.setItem(KEY, created);
    return created;
  } catch {
    return `disp-${crypto.randomUUID().slice(0, 18)}`;
  }
}
